import { Box, Typography } from '@mui/material';
import { memo } from 'react';

interface WeekNumbersColumnProps {
    weekNumbers: number[];
    textColor?: string;
    rowHeight?: number;
    rowMargin?: number;
    rowMarginBottom?: number;
    topPadding?: number;
}

const WeekNumbersColumn = memo(function WeekNumbersColumn({
    weekNumbers,
    textColor = '#666',
    rowHeight = 36,
    rowMargin = 1,
    rowMarginBottom,
    topPadding = 96,
}: WeekNumbersColumnProps) {
    const adjustedRowMargin = rowHeight > 40 ? 2 : rowMargin;
    const marginBottom = rowMarginBottom !== undefined ? rowMarginBottom : adjustedRowMargin;

    return (
        <Box
            className="week-numbers-column"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                minWidth: 36,
                pt: `${topPadding}px`,
            }}
        >
            {weekNumbers.map((weekNum, index) => (
                <Typography
                    key={index}
                    variant="caption"
                    className="week-number-row"
                    sx={{
                        height: rowHeight,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.75rem',
                        color: textColor,
                        fontWeight: 500,
                        minWidth: 24,
                        mt: `${adjustedRowMargin}px`,
                        mb: `${marginBottom}px`,
                    }}
                >
                    {weekNum}
                </Typography>
            ))}
        </Box>
    );
});

export default WeekNumbersColumn;
